// @flow
import type { FeedType } from 'app/common/redux/reducers/feeds';

export type FeedInvalidate = {
  type: 'FEED_INVALIDATE',
  payload: {
    feedType: FeedType,
    feedId: string,
  },
};

export default function invalidate(feedType: FeedType, feedId: string) {
  return { type: 'FEED_INVALIDATE', payload: { feedType, feedId } };
}
